import { render, staticRenderFns } from "./RewardsListIdeas.vue?vue&type=template&id=364c2e76&"
import script from "./RewardsListIdeas.vue?vue&type=script&lang=js&"
export * from "./RewardsListIdeas.vue?vue&type=script&lang=js&"
import style0 from "./RewardsListIdeas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports